import React from 'react';
import PropTypes from 'prop-types';
import useIntl from '@afosto/utils-react/intl/useIntl';
import { useAppState } from '@afosto/app-components-react/AppProvider';
import PickItemQuantityCounterContainer from '../PickItemQuantityCounterContainer';
import QuantityCounter from '@afosto/app-components-react/QuantityCounter';
import translations from './translations';

const PickItemQuantityCounter = ({ itemKey, counter }) => {
  const intl = useIntl();
  const { settings = {} } = useAppState();
  const itemsAllButtonSettings = settings?.general?.items_all_button ?? {};
  const atLeastOneProductManuallyValue =
    itemsAllButtonSettings?.at_least_one_product_manually ?? true;
  const minRequestedQuantityValue = itemsAllButtonSettings?.min_requested_quantity ?? 5;
  const { itemQuantities, handleAll, handleChange, handleMinus, handlePlus } = counter ?? {};
  const { quantity = 0, requested = 0 } = itemQuantities[itemKey] ?? {};
  const atLeastOneProductManually =
    (atLeastOneProductManuallyValue && quantity >= 1) || atLeastOneProductManuallyValue === false;
  const minRequestedQuantity = requested >= minRequestedQuantityValue;

  return (
    <QuantityCounter
      ContainerElement={PickItemQuantityCounterContainer}
      onAll={handleAll(itemKey)}
      onChange={handleChange(itemKey)}
      onMinus={handleMinus(itemKey)}
      onPlus={handlePlus(itemKey)}
      quantity={quantity}
      quantityLabel={intl.formatMessage(translations.properties.picked)}
      requested={requested}
      requestedLabel={intl.formatMessage(translations.properties.quantity)}
      showAllButton={atLeastOneProductManually && minRequestedQuantity}
    />
  );
};

PickItemQuantityCounter.propTypes = {
  counter: PropTypes.object,
  itemKey: PropTypes.string,
};

PickItemQuantityCounter.defaultProps = {
  counter: undefined,
  itemKey: undefined,
};

export default PickItemQuantityCounter;
